/**
 * Level-of-detail and resolution-tier policy. Centralized so the thresholds
 * that govern "when do we rasterize" live in one place (spec §6.4, §6.5).
 */

/** Discrete resolution tiers (texels per world px). Stepwise so zooming doesn't thrash. */
export const TIERS = [2, 4, 8] as const;

/**
 * Smallest tier whose texel density meets the on-screen density.
 * effectiveDensity = zoom * dpr. We want texels-per-world-px >= that for crisp text.
 */
export function tierFor(zoom: number, dpr: number): number {
  const need = zoom * dpr;
  for (const t of TIERS) {
    if (t >= need) return t;
  }
  return TIERS[TIERS.length - 1];
}
